import { makeAutoObservable, runInAction } from "mobx";

export interface IMigrationIframeStore {
	jwtToken: string | undefined;
	setProperty<K extends keyof IMigrationIframeStore>(key: K, value: IMigrationIframeStore[K]): void;
}

export class MigrationIframeStore implements IMigrationIframeStore {
	jwtToken: string | undefined;

	constructor() {
		makeAutoObservable(this);
	}

	setProperty = async <K extends keyof IMigrationIframeStore>(key: K, value: IMigrationIframeStore[K]) => {
		runInAction(() => ((this as IMigrationIframeStore)[key] = value));
	};
}

const migrationIframeStore = new MigrationIframeStore();
export default migrationIframeStore;
